import { CustomerReferralSource } from '@gql'
import { defineMessages, type IntlShape } from 'react-intl'

export const referralSourceMessages = defineMessages({
  advertisement: {
    defaultMessage: 'Advertisement',
    description: 'referral source title',
  },
  friendOrFamily: {
    defaultMessage: 'Friend or family',
    description: 'referral source title',
  },
  newsMedia: {
    defaultMessage: 'News / media',
    description: 'referral source title',
  },
  other: {
    defaultMessage: 'Other',
    description: 'referral source title',
  },
  searchEngine: {
    defaultMessage: 'Search engine',
    description: 'referral source title',
  },
  socialMedia: {
    defaultMessage: 'Social media',
    description: 'referral source title',
  },
  youtube: {
    defaultMessage: 'YouTube',
    description: 'referral source title',
  },
})

export function translateReferralSource(intl: IntlShape, source: CustomerReferralSource): string {
  switch (source) {
    case CustomerReferralSource.ADVERTISEMENT:
      return intl.formatMessage(referralSourceMessages.advertisement)
    case CustomerReferralSource.FRIEND_OR_FAMILY:
      return intl.formatMessage(referralSourceMessages.friendOrFamily)
    case CustomerReferralSource.NEWS_MEDIA:
      return intl.formatMessage(referralSourceMessages.newsMedia)
    case CustomerReferralSource.OTHER:
      return intl.formatMessage(referralSourceMessages.other)
    case CustomerReferralSource.SEARCH_ENGINE:
      return intl.formatMessage(referralSourceMessages.searchEngine)
    case CustomerReferralSource.SOCIAL_MEDIA:
      return intl.formatMessage(referralSourceMessages.socialMedia)
    case CustomerReferralSource.YOUTUBE:
      return intl.formatMessage(referralSourceMessages.youtube)
  }
}
